export const VOICE_TEST_IDS = {
  countdown: "voice-countdown",
};
